import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-评论管理",
  "use": "icon-评论管理-usage",
  "viewBox": "0 0 160 160",
  "content": "<symbol viewBox=\"0 0 160 160\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-评论管理\">\n<path d=\"M15 26.4C15 20.3249 19.9249 15.4 26 15.4H138C144.075 15.4 149 20.3249 149 26.4V114.4C149 120.475 144.075 125.4 138 125.4H117.423C114.28 125.4 111.215 126.388 108.663 128.224L88.7421 142.556C87.1415 143.707 85.0136 143.81 83.309 142.819L56.8436 127.432L54.3305 131.755L56.8436 127.432C54.554 126.101 51.9527 125.4 49.3043 125.4H26C19.9249 125.4 15 120.475 15 114.4V26.4Z\" stroke-width=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<circle cx=\"43.2\" cy=\"73.6\" r=\"9.4\" stroke-width=\"10\" />\n<circle cx=\"80.7999\" cy=\"73.6\" r=\"9.4\" stroke-width=\"10\" />\n<circle cx=\"118.4\" cy=\"73.6\" r=\"9.4\" stroke-width=\"10\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/评论管理.svg
// module id = s6+M
// module chunks = 26